import Axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL } from "./config";
import { AUTH_TYPES } from "./context/reducers/authReducers";
import useStore from "./context/useStore";
import useRole from "./hooks/useRole/useRole";

const RoleStyle = ({ children }) => {
  const [state, dispatch] = useStore();
  const [isLoadingRole, setIsLoadingRole] = useState(false);
  const [privCss, setPrivCss] = useState("");
  const {
    myRole,
    setMyRole,
    setMyPrivileges,
    myPrivileges,
    myHiddenPrivileges: hiddenPriv,
    setMyHiddenPrivileges: setHiddenPriv,
  } = useRole();

  useEffect(() => {
    if (state.auth.isAuthenticated) getConfig();
  }, [state.auth.isAuthenticated]);

  useEffect(() => {
    if (myPrivileges.length && hiddenPriv.length) {
      generateCss();
    }
  }, [myPrivileges, hiddenPriv]);

  const getConfig = () => {
    setIsLoadingRole(true);
    Axios.get(API_URL + "roles/mine")
      .then((res) => {
        if (res.data[0]) {
          setMyPrivileges(res.data[0].privileges);
          setHiddenPriv(res.data[0].privilegesOff);
          setMyRole(res.data[0].roleKey);
          dispatch({ type: AUTH_TYPES.SET_ROLE, payload: res.data[0].roleKey });
        }
      })
      .catch((err) => {})
      .finally(() => setIsLoadingRole(false));
  };

  const generateCss = () => {
    var css = "";
    hiddenPriv.map((h) => {
      css += "[data-priv='" + h + "'] { display: none !important;}";
    });
    setPrivCss(css);
  };

  const getRender = () => {
    if (!isLoadingRole) {
      if (myRole.length > 0) return children;
      return null;
    }
    return children;
  };

  return (
    <>
      {state.auth.isAuthenticated ? getRender() : children}
      <style
        dangerouslySetInnerHTML={{
          __html: `
          ${privCss}
      `,
        }}
      />
    </>
  );
};

export default RoleStyle;
